import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { useFloatingBottomBarSpacing } from '@order/shared-hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const FloatingBar = (props: PropsWithChildren) => {
  const { children } = props;

  const { floatingBottomBarStyle } = useFloatingBottomBarSpacing();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [styles.container, floatingBottomBarStyle];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles} pointerEvents="box-none">
      {children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    right: 0,
    left: 0,
    gap: theme.spacing['4'],
    marginHorizontal: theme.spacing['4'],
  },
});
